/**
 * Update cart icon accessible name with item count
 * Edited by Zenyth - Ensures cart link has descriptive accessible name
 */
function updateCartIconAccessibleName(itemCount) {
  const cartIcons = document.querySelectorAll('#cart-icon-bubble');
  cartIcons.forEach(function(icon) {
    var itemText = itemCount === 1 ? '1 item' : itemCount + ' items';
    var accessibleName = 'Cart, ' + itemText;
    icon.setAttribute('aria-label', accessibleName);
    
    // Update visually-hidden text if it exists
    var hiddenText = icon.querySelector('.visually-hidden');
    if (hiddenText) {
      hiddenText.textContent = ', ' + itemText;
    }
  });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

/*
 * -------------------------------------------------------------------------
 * GWP Controls: Manage the logic for the Gift With Purchase (GWP) feature
 * -------------------------------------------------------------------------
 */

// Toggle the GWP feature ON or OFF
// true = GWP is enabled | false = GWP is disabled
const gwpActivated = false;

// The VariantID of the free gift product to be added to the cart
const giftID = 45058804613172;

// Required number of items in the cart to qualify for the GWP
const numberOfItemsForGWP = 1;

/*
 * -------------------------------------------------------------------------
 * END of GWP Controls
 * -------------------------------------------------------------------------
 */



customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
    addToCartGWP()
  }

  onCartUpdate() {
    addToCartGWP()
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => {
          response.text()
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {   
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          // Edited by Zenyth - Fixed focus trap to include close button when cart becomes empty
          // Changed from trapping focus on .drawer__inner-empty to entire #CartDrawer container
          const containerToTrapFocusOn = document.getElementById('CartDrawer');
          const focusElement = cartDrawerWrapper.querySelector('.drawer__close') || cartDrawerWrapper.querySelector('.drawer__inner-empty a');
          trapFocus(containerToTrapFocusOn, focusElement);
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        // Edited by Zenyth - Update cart icon accessible name when cart count changes
        updateCartIconAccessibleName(parsedState.item_count);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(() => {
        this.disableLoading(line);
        addToCartGWP()
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) {
        errorText.innerHTML = message;
      }
    }

    // Safely handle cases where live region elements are not present
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');

    if (!cartStatus) {
      return;
    }

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) {
      document.activeElement.blur();
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


// DEPRECATED
function checkCartForTag(tag) {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      return Promise.all(
        cart.items.map(item => {
          return fetch(`${item.handle}` + '.json')
            .then(response => response.json())
            .then(res => {
              if (res.product.tags && res.product.tags.includes(tag)) {
                return true;
              }
              return false;
            });
        })
      ).then(results => results.includes(true));
    })
    .catch(error => {
      console.error('Error getting the cart:', error);
      return false;
    });
}

// Function to add a gift to the cart if it's not already present
function addToCartGWP(variantId = giftID, quantity = 1) {
  if (!gwpActivated) {
    return
  }
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Exclude the gift product when counting items
      const nonGiftItemsCount = cart.items.reduce((count, item) => {
        if (!(item.properties && item.properties._gwp_sale === "active")) {
          return count + item.quantity;
        }
        return count;
      }, 0);

      potLogger("Non-gift items count:", nonGiftItemsCount);
      potLogger("numberOfItemsForGWP", numberOfItemsForGWP);
      potLogger(nonGiftItemsCount > (numberOfItemsForGWP - 1));

      if (nonGiftItemsCount > (numberOfItemsForGWP - 1)) {
        // Check if the cart already has the gift product
        const hasGift = cart.items.some(item => item.id === giftID && item.properties && item.properties._gwp_sale === "active");
        potLogger("Gift product already in cart:", hasGift);

        if (!hasGift) {
          potLogger("Test hasGift", hasGift);

          // If the gift is not present, add it to the cart
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              properties: {
                "_gwp_sale": "active",
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            updateCartDrawer();
          })
          .catch(error => {
            console.error('Error on adding to cart:', error);
          });
        }
      } else {
        // Check if there is a product with the property "_gwp_sale": "active"
        const giftItem = cart.items.find(item => item.properties && item.properties._gwp_sale === "active");

        if (giftItem) {
          // Remove the gift item from the cart
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: giftItem.key, // Use the unique key to identify the cart item
              quantity: 0 // Set quantity to 0 to remove the item
            })
          })
          .then(response => response.json())
          .then(data => {
            updateCartDrawer();
          })
          .catch(error => {
            console.error('Error on removing gift from cart', error);
          });
        }
      }
    })
    .catch(error => {
      console.error('Error getting the cart:', error);
    });
}



function addCartAttribute() {
  potLogger(allTiers)
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      attributes: {
        ['_ctm_bays']: allTiers 
      }
    })
  })
  .then(response => {
    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    potLogger('Cart attribute added successfully:', data);
  })
  .catch(error => {
    console.error('Error on adding cart attribute', error);
  });
}
